

function addPlugins(config, slot_name, plugins) {
  if (slot_name in config.pluginSlots === false) {
    config.pluginSlots[slot_name] = {
      keepDefault: true,
      plugins: []
    };
  }

  config.pluginSlots[slot_name].plugins.push(...plugins);
}

async function setConfig () {
  let config = {
    pluginSlots: {}
  };

  try {
    /* We can't assume FPF exists, as it's not declared as a dependency in all
     * MFEs, so we import it dynamically. In addition, for dynamic imports to
     * work with Webpack all of the code that actually uses the imported module
     * needs to be inside the `try{}` block.
     */
    const { DIRECT_PLUGIN, PLUGIN_OPERATIONS } = await import('@openedx/frontend-plugin-framework');
    addPlugins(config, 'desktop_header_slot', [
    {
      op: PLUGIN_OPERATIONS.Hide,
      widgetId: 'default_contents'
    }
    ]);
    addPlugins(config, 'desktop_header_slot', [
    {
      op: PLUGIN_OPERATIONS.Insert,
      widget: {
        id: 'custom_desktop_header',
        type: DIRECT_PLUGIN,
        RenderWidget: () => {
          const React = require("react");
          const { FormattedMessage } = require('@edx/frontend-platform/i18n');
          const { useContext, useState, useRef, useEffect } = React;
          const { AppContext } = require("@edx/frontend-platform/react");
          const { FontAwesomeIcon } = require("@fortawesome/react-fontawesome");
          const { faUser, faGlobe } = require("@fortawesome/free-solid-svg-icons");
          const { useIntl } = require('react-intl');

          const { authenticatedUser, config } = useContext(AppContext);
          const intl = useIntl();
          const username = authenticatedUser?.username || intl.formatMessage({ id: 'general.guest', defaultMessage: 'Guest' });
          const isAuthenticated = !!authenticatedUser;
          const isAdministrator = authenticatedUser?.administrator === true;

          const [csrfToken, setCsrfToken] = useState('');
          const [languages, setLanguages] = useState([]);

          useEffect(() => {
            // Get CSRF token
            const meta = document.querySelector('meta[name="csrf_token"]');
            if (meta) {
              setCsrfToken(meta.getAttribute('content'));
            }

            // Get supported languages from config or fallback to hardcoded
            let supportedLanguages = config.SITE_SUPPORTED_LANGUAGES || config.AVAILABLE_LANGUAGES || [];
            if (supportedLanguages.length === 0) {
              // Fallback hardcoded (replace with actual released languages)
              supportedLanguages = [
                { code: 'en', name: 'English' },
                { code: 'ru', name: 'Русский' },
                { code: 'kk', name: 'Қазақша' },
              ];
            }
            // Format as array of [code, name] or {value, label} - adjust based on config format
            // Assuming config provides [{value: 'en', label: 'English'}, ...]
            setLanguages(supportedLanguages);

            // Alternative: Fetch from API if not in config
            // fetch('/lang_metadata_api/v1/locales/?limit=1000')
            //   .then(res => res.json())
            //   .then(data => setLanguages(data.results.filter(lang => lang.enabled).map(lang => ({code: lang.code, name: lang.name}))))
            //   .catch(() => setLanguages(hardcoded));
          }, [config]);

          const [dropdownOpen, setDropdownOpen] = useState(false);
          const dropdownRef = useRef(null);

          const currentLocale = intl.locale;
          const currentLanguageCode = currentLocale.split('-')[0];

          const showLanguageSelector = (config.ENABLE_HEADER_LANGUAGE_SELECTOR ?? true) && languages.length > 1;

          const handleLanguageChange = async (e) => {
            const selectedCode = e.target.value;
            if (selectedCode === currentLanguageCode) return;

            try {
              if (isAuthenticated && csrfToken) {
                // Update user preferences
                await fetch(`/user/v1/preferences/${username}/`, {
                  method: 'PATCH',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken,
                  },
                  body: JSON.stringify({
                    preference: { language: selectedCode }
                  }),
                });

                // Set language in session (for immediate effect)
                await fetch('/i18n/setlang/', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'X-CSRFToken': csrfToken,
                  },
                  body: `language=${encodeURIComponent(selectedCode)}`,
                });
              } else {
                // For guests: set cookie
                const cookieName = config.LANGUAGE_PREFERENCE_COOKIE_NAME || 'language';
                document.cookie = `${cookieName}=${selectedCode}; path=/; max-age=31536000`;
              }

              // Reload page to update all translations (necessary for MFE consistency)
              window.location.reload();
            } catch (error) {
              console.error('Failed to change language:', error);
              // Optionally show error toast
            }
          };

          const toggleDropdown = () => {
            setDropdownOpen(!dropdownOpen);
          };

          const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
              setDropdownOpen(false);
            }
          };

          useEffect(() => {
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
              document.removeEventListener("mousedown", handleClickOutside);
            };
          }, []);

          const navLinkStyle = {
            color: '#ffffff',
            textDecoration: 'none',
            fontWeight: 'bold',
            fontSize: '14px',
            whiteSpace: 'nowrap'
          };

          const navLinks = [
            { id: "nav.courses", defaultMessage: "Courses", href: "https://open.kaznu.kz/courses" },
            { id: "nav.competition", defaultMessage: "Competition", href: "https://open.kaznu.kz/competition" },
            { id: "nav.catalog", defaultMessage: "Catalog MOOC for Transfer", href: "https://open.kaznu.kz/catalog" },
            { id: "nav.authors", defaultMessage: "For Authors", href: "https://open.kaznu.kz/author" },
            { id: "nav.checking", defaultMessage: "The System of Checking", href: "https://open.kaznu.kz/checking" },
	          { id: "nav.news", defaultMessage: "News", href: "https://open.kaznu.kz/news" },
            ...(isAdministrator ? [
              { id: "nav.analyze", defaultMessage: "Analyze", href: "https://open.kaznu.kz/analyze" },
            ] : []),
          ];

          return (
            <header style={{
              backgroundColor: '#1a263c',
              position: 'relative',
              width: '100%'
            }}>
              {/*  */}
              <div style={{
                width: '90%',
                margin: '0 auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                height: '70px',
                padding: '0 20px',
                boxSizing: 'border-box',
                fontFamily: 'sans-serif'
              }}>
                {/*  */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '30px' }}>
                  <a href="/">
                    <img
                      src="https://open.kaznu.kz/static/images/logo.png"
                      alt="Р›РѕРіРѕС‚РёРї"
                      style={{ height: '40px' }}
                    />
                  </a>
                  <nav style={{ display: 'flex', gap: '20px' }}>
                    {navLinks.map((link, index) => (
                      <a
                        key={index}
                        href={link.href}
                        style={navLinkStyle}
                      >
                        <FormattedMessage
                          id={link.id}
                          defaultMessage={link.defaultMessage}
                        />
                      </a>
                    ))}
                  </nav>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  {showLanguageSelector && languages.length > 0 && (
                    <label style={{ margin: 0, fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <FontAwesomeIcon icon={faGlobe} style={{ color: '#d3985c', fontSize: '16px' }} />
                      <span className="sr-only">
                        <FormattedMessage 
                          id="language.selector.label" 
                          defaultMessage="Choose Language" 
                        />
                      </span>
                      <select 
                        className="input select language-selector" 
                        id="settings-language-value" 
                        value={currentLanguageCode}
                        onChange={handleLanguageChange}
                        style={{ borderRadius: '8px', padding: '5px 10px', fontSize: '14px' }}
                      >
                        {languages.map((lang) => {
                          const langCode = lang.code || lang.value;
                          const langName = lang.name || lang.label;
                          return (
                            <option 
                              key={langCode} 
                              value={langCode}
                            >
                              {langName}
                            </option>
                          );
                        })}
                      </select>
                    </label>
                  )}
                  <div ref={dropdownRef} style={{ position: 'relative' }}>
                    <div
                      onClick={toggleDropdown}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        border: '2px solid #ffffff',
                        borderRadius: '4px',
                        padding: '8px 12px',
                        cursor: 'pointer',
                        color: '#ffffff',
                        fontWeight: 'bold',
                        fontSize: '16px'
                      }}
                    >
                      <FontAwesomeIcon icon={faUser} />
                      {username}
                    </div>

                    {dropdownOpen && (
                      <div style={{
                        position: 'absolute',
                        right: 0,
                        top: '100%',
                        backgroundColor: '#ffffff',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                        marginTop: '8px',
                        zIndex: 1000,
                        minWidth: '160px'
                      }}>
                        {[
                          { href: '/', id: "nav.my_courses", text: "My Courses" },
                          { href: `/profile/u/${username}`, id: "nav.profile", text: "Profile" },
                          { href: '/account/', id: "nav.account", text: "Account" },
                          { href: 'https://open.kaznu.kz/logout', id: "nav.sign_out", text: "Sign out" }
                        ].map((item, i) => (
                          <a
                            key={i}
                            href={item.href}
                            style={{
                              display: 'block',
                              padding: '10px 16px',
                              color: '#1a263c',
                              textDecoration: 'none',
                              fontWeight: 'bold'
                            }}
                          >
                            <FormattedMessage id={item.id} defaultMessage={item.text} />
                          </a>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </header>
          );
        }
      }
    }
    ]);
    addPlugins(config, 'mobile_main_menu_slot', [
        {
            op: PLUGIN_OPERATIONS.Modify,
            widgetId: 'default_contents',
            fn: (widget) => {
                const React = require("react");
                const { FormattedMessage } = require('@edx/frontend-platform/i18n');
                const { getAuthenticatedUser } = require('@edx/frontend-platform/auth');
                const { useContext, useState, useEffect } = React;
                const { AppContext } = require("@edx/frontend-platform/react");
                const { useIntl } = require('react-intl');
                const isAdministrator = getAuthenticatedUser()?.administrator === true;

                const LanguageSelector = () => {
                  const { authenticatedUser, config } = useContext(AppContext);
                  const intl = useIntl();
                  const username = authenticatedUser?.username || '';
                  const isAuthenticated = !!authenticatedUser;
                  const [csrfToken, setCsrfToken] = useState('');
                  const [languages, setLanguages] = useState([]);

                  useEffect(() => {
                    const meta = document.querySelector('meta[name="csrf_token"]');
                    if (meta) {
                      setCsrfToken(meta.getAttribute('content'));
                    }

                    let supportedLanguages = config.SITE_SUPPORTED_LANGUAGES || config.AVAILABLE_LANGUAGES || [
                      { code: 'en', name: 'English' },
                      { code: 'ru', name: 'Русский' },
                      { code: 'kk', name: 'Қазақша' },
                    ];
                    setLanguages(supportedLanguages);
                  }, [config]);

                  const currentLocale = intl.locale;
                  const currentLanguageCode = currentLocale.split('-')[0];

                  const handleLanguageChange = async (e) => {
                    const selectedCode = e.target.value;
                    if (selectedCode === currentLanguageCode) return;

                    try {
                      if (isAuthenticated && csrfToken) {
                        await fetch(`/user/v1/preferences/${username}/`, {
                          method: 'PATCH',
                          headers: {
                            'Content-Type': 'application/json',
                            'X-CSRFToken': csrfToken,
                          },
                          body: JSON.stringify({
                            preference: { language: selectedCode }
                          }),
                        });
                        await fetch('/i18n/setlang/', {
                          method: 'POST',
                          headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'X-CSRFToken': csrfToken,
                          },
                          body: `language=${encodeURIComponent(selectedCode)}`,
                        });
                      } else {
                        const cookieName = config.LANGUAGE_PREFERENCE_COOKIE_NAME || 'language';
                        document.cookie = `${cookieName}=${selectedCode}; path=/; max-age=31536000`;
                      }
                      window.location.reload();
                    } catch (error) {
                      console.error('Failed to change language:', error);
                    }
                  };

                  if (languages.length <= 1) return null;

                  return (
                    <div style={{ 
                      padding: '12px 16px', 
                      borderTop: '1px solid #f2f2f2',
                      background: '#fafafa'
                    }}>
                      <select 
                        value={currentLanguageCode}
                        onChange={handleLanguageChange}
                        style={{ 
                          width: '100%', 
                          padding: '8px 12px',
                          borderRadius: '6px', 
                          border: '1px solid #ddd',
                          fontSize: '14px',
                          background: 'white',
                          color: '#333'
                        }}
                      >
                        {languages.map((lang) => {
                          const langCode = lang.code || lang.value;
                          const langName = lang.name || lang.label;
                          return (
                            <option key={langCode} value={langCode}>
                              {langName}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  );
                };

                widget.content.menu = [
                    {
                        type: 'item',
                        href: 'https://open.kaznu.kz/courses',
                        content: <FormattedMessage
                            id="nav.courses"
                            defaultMessage="Courses"
                        />,
                    },
                    {
                        type: 'item',
                        href: 'https://open.kaznu.kz/competition',
                        content: <FormattedMessage
                            id="nav.competition"
                            defaultMessage="Competition"
                        />,
                    },
                    {
                        type: 'item',
                        href: 'https://open.kaznu.kz/catalog_transfer',
                        content: <FormattedMessage
                            id="nav.catalog"
                            defaultMessage="Catalog MOOC for Transfer"
                        />,
                    },
                    {
                        type: 'item',
                        href: 'https://open.kaznu.kz/author',
                        content: <FormattedMessage
                            id="nav.authors"
                            defaultMessage="For Authors"
                        />,
                    },
                    {
                        type: 'item',
                        href: 'https://open.kaznu.kz/detect',
                        content: <FormattedMessage
                            id="nav.checking"
                            defaultMessage="The System of Checking"
                        />,
                    },

		                {
                        type: 'item',
                        href: 'https://open.kaznu.kz/news',
                        content: <FormattedMessage
                            id="nav.news"
                            defaultMessage="News"
                        />,
                    },
                    ...(isAdministrator ? [{
                        type: 'item',
                        href: 'https://open.kaznu.kz/analyze',
                        content: <FormattedMessage
                            id="nav.analyze"
                            defaultMessage="Analyze"
                        />,
                    }] : []),

                    // Добавляем селектор языка в конец меню
                    {
                        type: 'custom',
                        content: <LanguageSelector />,
                    },
                ];
                return widget;
            }
        }]);
    addPlugins(config, 'footer_slot', [
    {
      op: PLUGIN_OPERATIONS.Hide,
      widgetId: 'default_contents'
    }
    ]);
    addPlugins(config, 'footer_slot', [
    {
      op: PLUGIN_OPERATIONS.Insert,
      widget: {
        id: 'custom_footer',
        type: DIRECT_PLUGIN,
        RenderWidget: () => {
          const React = require("react");
          const { FormattedMessage } = require('@edx/frontend-platform/i18n');
          const { useEffect, useContext } = React;
          const { AppContext } = require("@edx/frontend-platform/react");
          const { authenticatedUser } = useContext(AppContext);
          const isAdministrator = authenticatedUser?.administrator === true;

          const { FontAwesomeIcon } = require("@fortawesome/react-fontawesome");
          const { library } = require("@fortawesome/fontawesome-svg-core");
          const {
            faMapMarkerAlt,
            faPhone,
            faBookOpen,
            faUsers,
            faCertificate
          } = require("@fortawesome/free-solid-svg-icons");
          const {
            faFacebook,
            faTwitter,
            faInstagram,
            faLinkedin,
            faYoutube
          } = require("@fortawesome/free-brands-svg-icons");

          library.add(
            faMapMarkerAlt,
            faPhone,
            faBookOpen,
            faUsers,
            faCertificate,
            faFacebook,
            faTwitter,
            faInstagram,
            faLinkedin,
            faYoutube
          );

          useEffect(() => {
            const animateNumber = (element, start, end, duration) => {
              let startTimestamp = null;
              const step = (timestamp) => {
                if (!startTimestamp) startTimestamp = timestamp;
                const progress = Math.min((timestamp - startTimestamp) / duration, 1);
                const number = Math.floor(progress * (end - start) + start);
                element.textContent = number + "+";
                if (progress < 1) {
                  window.requestAnimationFrame(step);
                }
              };
              window.requestAnimationFrame(step);
            };

            const startCounters = () => {
              document.querySelectorAll('.stat-number').forEach(element => {
                const target = parseInt(element.getAttribute('data-target'));
                animateNumber(element, 0, target, 2000);
              });
            };

            const observer = new IntersectionObserver((entries) => {
              entries.forEach(entry => {
                if (entry.isIntersecting) {
                  startCounters();
                  observer.unobserve(entry.target);
                }
              });
            });

            const footerEl = document.querySelector('.footer');
            if (footerEl) {
              observer.observe(footerEl);
            }
          }, []);

          const quickLinks = [
            { id: "footer.about_platform", default: "About Us" },
            { id: "footer.courses", default: "Courses" },
            { id: "footer.instructors", default: "For Authors" },
            { id: "footer.news", default: "News" },
            ...(isAdministrator ? [{
              id: "footer.analyze",
              default: "Analyze",
              href: "https://open.kaznu.kz/analyze",
            }] : []),
            { id: "footer.honor_code", default: "Honor Code" },
	        { id: "footer.terms_of_service", default: "Terms of service" },
	        { id: "footer.privacy_policy", default: "Privacy policy" },
          ];

          return (
             <footer
  className="footer"
  style={{
    backgroundColor: "#1a263c",
    color: "#D3985C",
    padding: "20px 0",
    fontFamily: "Arial, sans-serif"
  }}
>
  <div
    className="footer-container"
    style={{
      maxWidth: "1200px",
      margin: "0 auto",
      display: "flex",
      justifyContent: "space-between",
      flexWrap: "wrap",
      padding: "0 20px"
    }}
  >
    <div
      className="footer-column logo-column"
      style={{ flex: 1, minWidth: "250px", margin: "15px" }}
    >
      <a href="https://farabi.university/" style={{ textDecoration: "none" }}>
        <img
          src="https://farabi.university/front/assets/img/icons/logonew1.png"
          alt="Open.kaznu Logo"
          style={{ width: "200px", marginBottom: "20px" }}
        />
      </a>
      <div className="contact-list">
        <p style={{ display: "flex", alignItems: "center", margin: "15px 0", color: "white" }}>
          <FontAwesomeIcon
            icon=""
            style={{ marginRight: "15px", fontSize: "20px", color: "#D3985C" }}
          />
          <FormattedMessage id="footer.address" defaultMessage="Almaty, Al - Farabi 71" />
        </p>
        <p style={{ display: "flex", alignItems: "center", margin: "15px 0", color: "white" }}>
          <FontAwesomeIcon
            icon=""
            style={{
              marginRight: "15px",
              fontSize: "20px",
              color: "#D3985C",
              transform: "rotate(90deg)"
            }}
          />
          +7 (727) 123 11 33
        </p>
      </div>
    </div>

    <div className="footer-column" style={{ flex: 1, minWidth: "250px", margin: "15px" }}>
      <h3 style={{ color: "#D3985C", marginBottom: "25px" }}>
        <FormattedMessage id="footer.quick_links" defaultMessage="Quick Links" />
      </h3>
      <ul className="quick-links" style={{ listStyle: "none", padding: 0 }}>
        {quickLinks.map(link => (
          <li key={link.id} style={{ margin: "12px 0" }}>
            <a href={link.href || "#"} style={{ color: "white", textDecoration: "none" }}>
              <FormattedMessage id={link.id} defaultMessage={link.default} />
            </a>
          </li>
        ))}
      </ul>
    </div>

    <div className="footer-column" style={{ flex: 1, minWidth: "250px", margin: "15px" }}>
      <h3 style={{ color: "#D3985C", marginBottom: "25px" }}>
        <FormattedMessage id="footer.statistics" defaultMessage="Statistics" />
      </h3>
      <div className="stats-container" style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
        {[
          { icon: "book-open", label: "footer.stats.courses", defaultMessage: "Courses", target: 90 },
          { icon: "users", label: "footer.stats.users", defaultMessage: "Users", target: 77000 },
          { icon: "certificate", label: "footer.stats.certificates", defaultMessage: "Certificates", target: 6500 }
        ].map(stat => (
          <div
            className="stat-card"
            key={stat.label}
            style={{
              background: "rgba(255,255,255,0.1)",
              padding: "15px",
              borderRadius: "8px",
              textAlign: "center",
              flex: 1,
              minWidth: "120px",
              color: "white"
            }}
          >
            <FontAwesomeIcon
              icon={stat.icon}
              style={{ fontSize: "30px", color: "#D3985C", marginBottom: "10px" }}
            />
            <div
  className="stat-number"
  data-target={stat.target}
  style={{ fontSize: "28px", fontWeight: "bold", margin: "10px 0", color: "#D3985C" }}
>
  0
</div>


            <span style={{ color: "white" }}>
              <FormattedMessage id={stat.label} defaultMessage={stat.defaultMessage} />
            </span>
          </div>
        ))}
      </div>

      <h3 style={{ color: "#D3985C", marginTop: "30px" }}>
        <FormattedMessage id="footer.social" defaultMessage="We are on social media" />
      </h3>
      <div className="social-icons" style={{ display: "flex", marginTop: "15px" }}>
        {["facebook", "twitter", "instagram", "linkedin", "youtube"].map(platform => (
          <a
            key={platform}
            href="#"
            style={{ color: "white", fontSize: "24px", marginRight: "20px" }}
          >
            <FontAwesomeIcon icon={['fab', platform]} />
          </a>
        ))}
      </div>
    </div>
  </div>

<div
  className="copyright"
  style={{
    textAlign: "center",
    marginTop: "40px",
    paddingTop: "20px",
    borderTop: "1px solid #3e5b7a",
    color: "white"
  }}
>
  <p>© 2025 Open KazNU. <FormattedMessage id="footer.rights" defaultMessage="All rights reserved" /></p>
  <p><FormattedMessage id="footer.developed" defaultMessage="Developed by the Office of OAICI" /></p>
</div>

</footer>


          );
        }
      }
    }
    ]);
    if (process.env.APP_ID == 'authn') {
    }
    if (process.env.APP_ID == 'authoring') {
    }
    if (process.env.APP_ID == 'account') {
    }
    if (process.env.APP_ID == 'communications') {
    }
    if (process.env.APP_ID == 'discussions') {
    }
    if (process.env.APP_ID == 'gradebook') {
    }
    if (process.env.APP_ID == 'learner-dashboard') {
    }
    if (process.env.APP_ID == 'learning') {
    }
    if (process.env.APP_ID == 'ora-grading') {
    }
    if (process.env.APP_ID == 'profile') {
    }
  } catch (err) { console.error("env.config.jsx failed to apply: ", err);}

  return config;
}

export default setConfig;